// Home page -- featured collection silder in tab section 
function featuredCollectionSLider(){
  $('.feature-collection-slider').slick({
    slidesToShow: 4,
    slidesToScroll: 4,
    autoplay: false,
    autoplaySpeed: 2000,
    dots: true,
    responsive: [
    {
      breakpoint: 990,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
        arrows: false
      }
    },
    {
      breakpoint: 769,
      settings: {
        centerMode: true,
        centerPadding: '30%',
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        dots: false
      }
    },
    {
      breakpoint: 601,
      settings: {
        centerMode: true,
        centerPadding: '20%',
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        dots: false
      }
    }
  ]
  });

  if ( $(window).width() < 990 ) { 
    $('.feature-collection-slide-4').slick({
      slidesToShow: 3,
      slidesToScroll: 3,
      autoplay: false,
      autoplaySpeed: 2000,
      dots: true,
      arrows: false,
      responsive: [
      {
          breakpoint: 769,
          settings: {
            centerMode: true,
            centerPadding: '30%',
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            dots: false
          }
        },
        {
          breakpoint: 601,
          settings: {
            centerMode: true,
            centerPadding: '10%',
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            dots: false
          }
        }
      ]
    });
  }
}

const tabs = document.querySelectorAll('.collection-tab-header-list li a');
const tab_content = document.querySelectorAll('.collection-tc');

tabs.forEach((tab) => {
  tab.addEventListener('click', (tabvalue) => {
    const tab_content_id = tabvalue.target.getAttribute('data-tab');
    tabs.forEach(el => {
      el.parentNode.classList.remove('active-tab');
    });
    tabvalue.target.parentNode.classList.add('active-tab');
    tab_content.forEach(content => {
      content.style.display = "none";
      content.querySelector("ul.product-grid").classList.remove("active");
    });
    var tab = document.getElementById(tab_content_id)
    tab.style.display = "block";
    tab.querySelector("ul.product-grid").classList.add("active");

    // Check if the sliders exist before trying to unslick them
    if ($('.feature-collection-slider').hasClass('slick-initialized')) {
      $('.feature-collection-slider').slick('unslick');
    }
    if ($('.feature-collection-slide-4').hasClass('slick-initialized')) {
      $('.feature-collection-slide-4').slick('unslick'); 
    }
    featuredCollectionSLider(); // Initialize sliders after unslick if necessary
  });
});

featuredCollectionSLider();
// End ---- Home page -- featured collection silder in tab section 


//Home page -- featured on section (logo section) 
$('.logolist-slider.slider-active').slick({
  slidesToShow: 5,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 2000,
  dots:false,
  arrows: false,
  responsive: [
      {
          breakpoint: 769,
          settings: {
            centerMode: true,
            slidesToShow: 4,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 601,
          settings: {
            centerMode: true,
            slidesToShow: 3,
            slidesToScroll: 1
          }
        }
      ]
});

$blog_slider_dots = ($('.insta-image-list').attr('data-slider-dots') == 'true') ? true : false;
$blog_slider_arrows = ($('.insta-image-list').attr('data-slider-arrows') == 'true') ? true : false;
$('.insta-image-list').slick({
  slidesToShow: 5,
  slidesToScroll: 1,
  autoplay: false,
  autoplaySpeed: 2000,
  dots:$blog_slider_dots,
  arrows:$blog_slider_arrows,
  responsive: [
    { 
      breakpoint: 990,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1
      }
    },
    {
        breakpoint: 769,
        settings: {
          centerMode: true,
          centerPadding: '30%',
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: $blog_slider_arrows
        }
      }
  ]
});
$('.testimonial-list').slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 2000,
  centerMode: true,
  centerPadding: '0px',
  dots:true,
  arrows: false,
  // prevArrow: '.slick-prev.testimonial-slick-arrow',
  // nextArrow: '.slick-next.testimonial-slick-arrow',
  // responsive: [
  //   { 
  //     breakpoint: 990,
  //     settings: {
  //       slidesToShow: 2,
  //       slidesToScroll: 1,
  //       arrows: false
  //     }
  //   },
  //   {
  //     breakpoint: 769,
  //     settings: {
  //       slidesToShow: 1,
  //       slidesToScroll: 1,
  //       arrows: false
  //     }
  //   }
  // ]
});



$('.about-gallery-slider').slick({
      slidesToShow: 4,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 2000,
      centerMode: true,
      centerPadding: '10vw',
      dots: false,
      arrows: false,
      responsive: [
    {
      breakpoint: 1367,
      settings: {
        slidesToShow: 3
      }
    },
    {
      breakpoint: 769,
      settings: {
        centerMode: true,
        centerPadding: '30%',
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        dots: false
      }
    },
    {
      breakpoint: 601,
      settings: {
        centerMode: true,
        centerPadding: '30%',
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        dots: false
      }
    }
  ]
});

if ( $(window).width() < 990 ){
  $('.blog-list-slider').slick({
      slidesToShow: 2,
      slidesToScroll: 1,
      dots: false,
      arrows: false, 
      responsive: [
      {
        breakpoint: 749,
        settings: {
          slidesToShow: 1
        }
      }
    ]
  });
  $('.pdp-column-section .column-list-wrap').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    dots:true,
    arrows: true
  });
}
if ( $(window).width() < 750 ){
  $('.about-iconlist-section .multicolumn-list').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    dots:true,
    arrows: true
  });
}

$(document).on('click','.js-load-more',function(e){
   e.preventDefault();    
   $('.blog-articles__article').show();
   $(this).hide();
});   
// $(document).on('click','.js-load-more',function(e){
//     e.preventDefault();      
//     var $this = $(this);
//     var total_page = $('[data-total-pages]').val();  
//     var current_page = parseInt($('[data-current-page]').val());      
//     current_page = current_page + 1;
//     var next_url = $('[data-next-url]').val().replace(/page=[0-9]+/,'page='+current_page);
//     $this.attr('disabled', true);
//     $('.load-more_wrap').hide();
//     $('[data-current-page]').val(current_page);
  
//     $.ajax({
//       url: next_url,
//       type: 'GET',
//       dataType: 'html',
//       success: function(responseHTML){
//         $('.blog-articles').append($(responseHTML).find('.blog-articles').html());
//       },
//       complete: function() {
//         if(current_page < total_page) {
//            $this.attr('disabled', false); 
//            $('.load-more_wrap').show(); 
//         } 
//       }
//     });
//   }); 


// $('.drawer-related-slider').slick({
//     slidesToShow: 2,
//     slidesToScroll: 1,
//     dots:false,
//     arrows: true,
//     prevArrow:".related-product_list-title .drp-prev",
//     nextArrow:".related-product_list-title .drp-next"
//   });

// $('.cart-quantity-dropdown select').on('change',function(event){
//   event.preventDefault();
//   var item_quantity = parseInt($(this).val()) + 1;
//   console.log(item_quantity);
//   $(this).closest('.quantity-popover-container').find('input.quantity__input').val(item_quantity);
//   setTimeout(function(){
//     $(this).closest('.quantity-popover-container').find('button[name="minus"]').trigger('click');
//   },1000);
// });




$(".banner-slider").slick({
 slidesToShow: 1,
 infinite:true,
 slidesToScroll: 1,
 dots: true, 
 arrows: true
});


function initSlickSlider() {
  $('.cstm-coll-prod-slider').each(function(index, $slider) {
    var $slidertoshow = parseInt($(this).attr('data-prod-slider'));
    var $arrows = true;
    
    // Set the mobile-specific value
    if ($(window).width() < 749) {
      $slidertoshow = 2.6;  // Mobile-specific value
      $arrows = false;
    }

  
    // Destroy existing slick instance if initialized
    if ($(this).hasClass('slick-initialized')) {
      $(this).slick('unslick');
    }

    // Reinitialize slick with responsive settings    
    $(this).slick({
      slidesToShow: $slidertoshow,
      slidesToScroll: 4,
      dots: false,
      arrows: $arrows,
      infinite: false
    });
    

    // Additional logic to hide the slider if certain conditions are met
    if ($(window).width() < 749 && $(this).attr('data-prod-slider') == 3) {
      $(this).hide();
    }else{
      $(this).show();
    }
  });
}

function blog_slider(){
  if ($(window).width() < 575 && $('.blog-slider').attr('data-mob-slider') == 'true') { 
    if (!$('.blog-slider').hasClass('slick-initialized')) {
      $('.blog-slider').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: false,
        autoplaySpeed: 2000,
        // centerMode: true,
        // centerPadding: '0px',
        dots:false,
        arrows: false
      }); 
    }
  }
  else{
    if ($('.blog-slider').hasClass('slick-initialized')) {
      $('.blog-slider').slick('unslick');
    }
  }
}

// Initialize the slider on page load
$(document).ready(function() {
  initSlickSlider();
  blog_slider();
});

// Reinitialize the slider on window resize
$(window).resize(function() {
  initSlickSlider();
  blog_slider();
});


// $('.custom-product .slider-content').slick({
//   autoplay: false,
//   slidesToScroll: 1,
//   slidesToShow: 1,
//   arrows: false,
//   dots: false,
//   fade: false,
//   infinite: false,
//   asNavFor: '.custom-product .slider-thumb',
// });
  
// $('.custom-product .slider-thumb').slick({
//   slidesToShow: 4,
//   slidesToScroll: 1,
//   asNavFor: '.custom-product .slider-content',
//   dots: false,
//   centerMode: false,
//   focusOnSelect: true,
//   infinite: false, 
// });



